<div>
  <nz-card>
    <app-st-icon [avatar]="true" [bold]="true" name="description"></app-st-icon>
    @if (form.status === 'pending') {
      <span>{{form.file.name}}</span>
    }
    @if (form.status !== 'pending') {
      <nz-progress nzType="line" [nzShowInfo]="false" nzSize="default"
                   [nzStrokeWidth]="4" [nzPercent]="form.progress"
                   [nzStrokeColor]="form.status === 'uploading' ? '#0068D6'
                                                    : (form.status === 'success' ? '#45DEC5' : '#DA2F35')"
      ></nz-progress>
    }
  </nz-card>

  @if (!onlyReturnFiles) {
    <div class="select-wrapper">
      <nz-select class="larger" [(ngModel)]="form.documentType" [nzSize]="(screenService.isMobile$ | async) ? 'default' : 'large'"
                 [nzDisabled]="disabled" [nzSuffixIcon]="customSelectIcon" nzShowSearch
                 nzPlaceHolder="Selecciona el tipo de documento">
        @for (opt of documentTypes; track opt) {
          <nz-option [nzLabel]="opt.name" [nzValue]="opt.name"></nz-option>
        }
        <ng-template #customSelectIcon>
          <app-st-icon class="custom-suffix" name="keyboard_arrow_down"></app-st-icon>
        </ng-template>
      </nz-select>
      <span>Tipo de documento</span>
    </div>
  }

  @if (!onlyReturnFiles) {
    <div class="select-wrapper partner-select">
      <nz-date-picker class="larger" [(ngModel)]="form.expirationDate"
                      [nzSize]="(screenService.isMobile$ | async) ? 'default' : 'large'"
                      nzFormat="dd-MM-yyyy"
                      nzPlaceHolder="Selecciona la fecha de expiración"
      ></nz-date-picker>

      <span>Fecha de expiración</span>
    </div>
  }

  <button nz-button nzSize="large" class="larger" nzType="text" nzShape="circle" (click)="emitDeleteEvent()" nzDanger>
    <app-st-icon [bold]="true" name="delete"></app-st-icon>
  </button>
</div>
